import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Clients from "./scenes/clients";
import Employees from "./scenes/employees";
import Contracts from "./scenes/contracts";
import Suppliers from "./scenes/suppliers";
import Materials from "./scenes/materials";
import SupportTickets from "./scenes/supporttickets";
import SupportTicketsByStatus from "./scenes/supporttickets/indexByStatus";
import SupportTicketsByIssueType from "./scenes/supporttickets/indexByIssueType";
import SupportTicketsByPriority from "./scenes/supporttickets/indexByPriority";
import ServiceSchedule from "./scenes/serviceschedule";
import ServiceScheduleByServiceStatus from "./scenes/serviceschedule/indexByServiceStatus";
import JobApplications from "./scenes/jobapplications";
import SupplierContracts from "./scenes/suppliercontracts";
import ClientFeedback from "./scenes/clientfeedback";
import ClientFeedbackByResponseStatus from "./scenes/clientfeedback/indexByResponseStatus";
import Tasks from "./scenes/tasks";
import TasksByStatus from "./scenes/tasks/indexByStatus";
import TasksByPriority from "./scenes/tasks/indexByPriority";
import Projects from "./scenes/projects";
import Payments from "./scenes/payments";
import PaymentsByStatus from "./scenes/payments/indexByStatus";
import PaymentsByCurrency from "./scenes/payments/indexByCurrency";
import PaymentsByBillingCycle from "./scenes/payments/indexByBillingCycle";
import PaymentsByRefundStatus from "./scenes/payments/indexByRefundStatus";
import Equipment from "./scenes/equipment";
import EquipmentByStatus from "./scenes/equipment/indexByStatus";
import EquipmentByType from "./scenes/equipment/indexByType";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/clients" element={<ProtectedRoute element={<Clients searchTerm={searchTerm} />} />} />
<Route path="/employees" element={<ProtectedRoute element={<Employees searchTerm={searchTerm} />} />} />
<Route path="/contracts" element={<ProtectedRoute element={<Contracts searchTerm={searchTerm} />} />} />
<Route path="/suppliers" element={<ProtectedRoute element={<Suppliers searchTerm={searchTerm} />} />} />
<Route path="/materials" element={<ProtectedRoute element={<Materials searchTerm={searchTerm} />} />} />
<Route path="/supporttickets" element={<ProtectedRoute element={<SupportTickets searchTerm={searchTerm} />} />} />
<Route path="/supporttickets/list" element={<ProtectedRoute element={<SupportTickets searchTerm={searchTerm} />} />} />
<Route path="/supporttickets/status" element={<ProtectedRoute element={<SupportTicketsByStatus searchTerm={searchTerm} />} />} />
<Route path="/supporttickets/issuetype" element={<ProtectedRoute element={<SupportTicketsByIssueType searchTerm={searchTerm} />} />} />
<Route path="/supporttickets/priority" element={<ProtectedRoute element={<SupportTicketsByPriority searchTerm={searchTerm} />} />} />
<Route path="/serviceschedule" element={<ProtectedRoute element={<ServiceSchedule searchTerm={searchTerm} />} />} />
<Route path="/serviceschedule/list" element={<ProtectedRoute element={<ServiceSchedule searchTerm={searchTerm} />} />} />
<Route path="/serviceschedule/servicestatus" element={<ProtectedRoute element={<ServiceScheduleByServiceStatus searchTerm={searchTerm} />} />} />
<Route path="/jobapplications" element={<ProtectedRoute element={<JobApplications searchTerm={searchTerm} />} />} />
<Route path="/jobapplications/list" element={<ProtectedRoute element={<JobApplications searchTerm={searchTerm} />} />} />
<Route path="/suppliercontracts" element={<ProtectedRoute element={<SupplierContracts searchTerm={searchTerm} />} />} />
<Route path="/suppliercontracts/list" element={<ProtectedRoute element={<SupplierContracts searchTerm={searchTerm} />} />} />
<Route path="/clientfeedback" element={<ProtectedRoute element={<ClientFeedback searchTerm={searchTerm} />} />} />
<Route path="/clientfeedback/list" element={<ProtectedRoute element={<ClientFeedback searchTerm={searchTerm} />} />} />
<Route path="/clientfeedback/responsestatus" element={<ProtectedRoute element={<ClientFeedbackByResponseStatus searchTerm={searchTerm} />} />} />
<Route path="/tasks" element={<ProtectedRoute element={<Tasks searchTerm={searchTerm} />} />} />
<Route path="/tasks/list" element={<ProtectedRoute element={<Tasks searchTerm={searchTerm} />} />} />
<Route path="/tasks/status" element={<ProtectedRoute element={<TasksByStatus searchTerm={searchTerm} />} />} />
<Route path="/tasks/priority" element={<ProtectedRoute element={<TasksByPriority searchTerm={searchTerm} />} />} />
<Route path="/projects" element={<ProtectedRoute element={<Projects searchTerm={searchTerm} />} />} />
<Route path="/projects/list" element={<ProtectedRoute element={<Projects searchTerm={searchTerm} />} />} />
<Route path="/payments" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/list" element={<ProtectedRoute element={<Payments searchTerm={searchTerm} />} />} />
<Route path="/payments/status" element={<ProtectedRoute element={<PaymentsByStatus searchTerm={searchTerm} />} />} />
<Route path="/payments/currency" element={<ProtectedRoute element={<PaymentsByCurrency searchTerm={searchTerm} />} />} />
<Route path="/payments/billingcycle" element={<ProtectedRoute element={<PaymentsByBillingCycle searchTerm={searchTerm} />} />} />
<Route path="/payments/refundstatus" element={<ProtectedRoute element={<PaymentsByRefundStatus searchTerm={searchTerm} />} />} />
<Route path="/equipment" element={<ProtectedRoute element={<Equipment searchTerm={searchTerm} />} />} />
<Route path="/equipment/list" element={<ProtectedRoute element={<Equipment searchTerm={searchTerm} />} />} />
<Route path="/equipment/status" element={<ProtectedRoute element={<EquipmentByStatus searchTerm={searchTerm} />} />} />
<Route path="/equipment/type" element={<ProtectedRoute element={<EquipmentByType searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
